import L from 'leaflet'

const CircleMarkerText = L.CircleMarker.extend({
  options: {
    text: '',
    fontWeight: 'bold',
    fontSize: 14,
    fontSizeUnits: 'px',
    fontFamily: 'Verdana',
    textAlign: 'center',
    textBaseLine: 'middle',
    textColor: '#000000',
    textMargin: 4,
    textPadding: 6,
    minPixelDistance: 5
  },

  _updatePath() {
    L.CircleMarker.prototype._updatePath.call(this)
    this._renderer._updateCircleText(this)
  }
})

export function circleMarkerText(...options) {
  return new CircleMarkerText(...options)
}

L.circleMarkerText = circleMarkerText

export default CircleMarkerText



// WEBPACK FOOTER //
// ./src/helpers/leaflet-circle-marker-text.js